<template>
  <div class="read-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem to="/read">资料</shBreadItem>
    </shBread>
  </div>
  <div class="banner">
    <ReadBanner />
  </div>
  <div class="read-list">
    <div class="read-title">
      <i></i>
      <h3>下载资料列表</h3>
    </div>
    <hr />
    <ReadCategory />
  </div>
  <div class="read-item">
    <div>
      <!-- 资料区下载列表  read-list -->
      <ReadList :filesRead="filesRead" />
      <div class="pagenation">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          @size-change="changeSize"
          @current-change="currentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          background
          layout="total,  prev, pager, next"
          :total="filesCount"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 资料下载页面右侧--视频课程推荐 -->
    <VideoRecommend :VideoReCommend="VideoReCommend" />
  </div>
</template>

<script>
import { findVideoRecommand, findVideoRandom } from "@/api/video";
import ReadCategory from "./compontents/read-category.vue";
import ReadList from "./compontents/read-list";
import ReadBanner from "./compontents/read-banner";
import VideoRecommend from "../../components/video-recommend.vue";
import { findRead } from "@/api/read";
import { ref, watch, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
export default {
  name: "Read",
  components: {
    ReadCategory,
    ReadList,
    VideoRecommend,
    ReadBanner,
  },
  setup() {
    const route = useRoute();
    const filesRead = ref([]);
    const VideoReCommend = ref([]);
    //总页数
    const filesCount = ref(0);
    //当前页码
    const currentPage = ref(1);
    //每页数
    const pageSize = ref(20);
    findRead({
      maID: route.query.maID,
      chID: route.query.firstCate,
      coID: route.query.secondCate,
      clID: route.query.thirdCate,
      size: pageSize.value,
      page: currentPage.value,
    })
      .then((data) => {
        filesRead.value = data.result;
        if (data.resultLength.length) {
          filesCount.value = data.resultLength[0].totalCount;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    watch([currentPage, pageSize], () => {
      findRead({
        maID: route.query.maID,
        chID: route.query.firstCate,
        coID: route.query.secondCate,
        clID: route.query.thirdCate,
        size: pageSize.value,
        page: currentPage.value,
      })
        .then((data) => {
          //console.log(data);
          (filesRead.value = null),
            nextTick(() => {
              filesRead.value = data.result;
              if (data.resultLength.length) {
                filesCount.value = data.resultLength[0].totalCount;
              }
              //console.log(data.resultLength[0].totalCount);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    });
    watch(
      () => [route.query, route.fullPath],
      (newValue, oldValue) => {
        findRead({
          maID: route.query.maID,
          chID: route.query.firstCate,
          coID: route.query.secondCate,
          clID: route.query.thirdCate,
          size: pageSize.value,
          page: currentPage.value,
        })
          .then((data) => {
            //console.log(data);
            (filesRead.value = null),
              nextTick(() => {
                filesRead.value = data.result;
                if (data.resultLength.length) {
                  filesCount.value = data.resultLength[0].totalCount;
                }
                //console.log(data.resultLength[0].totalCount);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    );
    //监控clID并获取相应推荐
    watch(
      () => route.query.thirdCate,
      () => {
        //获取视频推荐

        if (route.query.thirdCate) {
          const clID = route.query.thirdCate?.split(",");
          findVideoRecommand(clID)
            .then((data) => {
              VideoReCommend.value = data.map((item) => {
                return {
                  chID: item.chID,
                  maID: item.maID,
                  coID: item.coID,
                  clID: item.clID,
                  leName: item.leName,
                  leImg: "/web/" + item.leImg,
                  coverImg: "/web/" + item.coverImg,
                  grade: item.grade.find((ele) => ele._id == item.gradeID),
                  id: item._id,
                };
              });
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          findVideoRandom(10)
            .then((data) => {
              VideoReCommend.value = data.map((item) => {
                return {
                  chID: item.chID,
                  maID: item.maID,
                  coID: item.coID,
                  clID: item.clID,
                  leName: item.leName,
                  leImg: "/web/" + item.leImg,
                  coverImg: "/web/" + item.coverImg,
                  grade: item.grade.find((ele) => ele._id == item.gradeID),
                  id: item._id,
                };
              });
            })
            .catch((error) => {
              console.log(error);
            });
        }
      },
      { immediate: true }
    );

    //换行
    const currentChange = (page) => {
      try {
        currentPage.value = page;
      } catch (error) {
        console.log(error);
      }
    };
    const changeSize = (size) => {
      try {
        pageSize.value = size;
      } catch (error) {
        console.log(error);
      }
    };
    return {
      ReadBanner,
      filesRead,
      changeSize,
      currentChange,
      filesCount,
      currentPage,
      pageSize,
      VideoReCommend,
    };
  },
};
</script>

<style lang="less" scoped>
.read-bread {
  background: @shColor;
  margin-bottom: 15px;
}

.read-list {
  width: 1240px;
  margin: 0 auto;
  background: #fff;

  margin-top: 25px;
  .read-title {
    display: flex;
    height: 50px;
    align-items: center;
    i {
      display: inline-block;
      height: 20px;
      width: 3px;
      background: @shColor;
    }
    h3 {
      margin-left: 8px;
    }
  }
  hr {
    height: 1px;
    border: none;
    border-top: 1px solid rgb(245, 245, 245);
    margin-top: 0px;
    margin-bottom: 0px;
  }
}
.read-item {
  display: flex;
  justify-content: space-between;
  width: 1240px;

  // background: #fff;
  margin: 0 auto;
  margin-top: 15px;
}
.pagenation {
  display: flex;
  justify-content: center;
  width: 830px;
  margin: 25px auto;
}
</style>
